import { LogLevel, Logger } from './logger.model';
import { Stopwatch } from './stopwatch';

export class WrappedLogger implements Logger {
  constructor(private logger: Logger, private context?: any) {}

  public logMessage(level: LogLevel, message: string, data?: any, context?: any): void {
    const allContext = {
      ...this.context,
      ...context
    };

    this.logger.logMessage(level, message, data, allContext);
  }

  public logDebug(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Debug, message, data, context);
  }

  public logTrace(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Trace, message, data, context);
  }

  public logInfo(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Info, message, data, context);
  }

  public logWarning(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Warning, message, data, context);
  }

  public logError(message: string, data?: any, context?: any): void {
    this.logMessage(LogLevel.Error, message, data, context);
  }

  public withContext(context: any): Logger {
    const allContext = {
      ...this.context,
      ...context
    };

    return new WrappedLogger(this, allContext);
  }

  public withMethod(method: string): Logger {
    const allContext = {
      ...this.context,
      method
    };

    return new WrappedLogger(this, allContext);
  }

  public startStopwatch(logLevel: LogLevel, message?: string, data?: any): Stopwatch {
    return new Stopwatch(this, logLevel, message, data);
  }
}
